import { Col, Row, TextInput } from 'ui';

export type JoinedOrganizationsListFiltersFormValues = {
  search?: string;
};
const JoinedOrganizationsListFilters = () => (
  <Row>
    <Col span={24}>
      <TextInput hasSearch item={{ label: 'Search', name: 'search' }} />
    </Col>
  </Row>
);

export default JoinedOrganizationsListFilters;
